// src/components/YearBarChart.tsx
import { Box } from "@material-ui/core";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import React, { useRef } from "react";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const COLORS = [
  "#0072B2", // Blue
  "#D55E00", // Vermillion
  "#009E73", // Teal green
  "#CC79A7", // Reddish purple
  "#F0E442", // Yellow
  "#56B4E9", // Sky blue
];

export default function YearBarChart({
  series,
  unit,
  activeYears,
  height = 400,
  fixedExtent,
}) {
  const chartRef = useRef();

  const chartData = {
    labels: series.map((d) => d.month),
    datasets: [...activeYears].sort().map((yr, i) => ({
      label: yr,
      data: series.map((r) => r[yr] ?? null),
      backgroundColor: COLORS[i % COLORS.length],
      maxBarThickness: 18,
    })),
  };

  const options = {
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      axis: "x",
      intersect: false,
    },
    plugins: {
      tooltip: {
        mode: "index",
        axis: "x",
        intersect: false,
        padding: 12,
        borderWidth: 1,
        borderColor: "#999",
        backgroundColor: "#fff",
        titleColor: "#333",
        bodyColor: "#333",
        cornerRadius: 6,
        titleFont: { weight: "bold", size: 14 },
        bodyFont: { size: 14 },
        callbacks: {
          title: (items) => items?.[0]?.label ?? "",
          label: (ti) => {
            const val = ti.raw;
            if (val == null) return undefined;
            const year = ti.dataset.label;
            return `${year}: ${val.toFixed(2)} ${unit}`;
          },
        },
      },
      legend: {
        position: "top",
      },
    },
    scales: {
      y: {
        title: { display: true, text: `Concentration (${unit})` },
        beginAtZero: true,
        ...(fixedExtent ? { min: fixedExtent[0], max: fixedExtent[1] } : {}),
      },
    },
  };

  return (
    <Box height={height} width="100%">
      <Bar ref={chartRef} data={chartData} options={options} />
    </Box>
  );
}
